import { useEffect, useState } from 'react';
import { Landing } from './components/Landing';
import { Dashboard } from './components/Dashboard';

const STORAGE_KEY = 'coastline-k9-retro-user';

export default function App() {
  const [user, setUser] = useState<{ name: string; isAdmin: boolean; key?: string } | null>(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) setUser(JSON.parse(raw));
    } catch { /* noop */ }
  }, []);

  const signIn = (name: string, isAdmin: boolean, key?: string) => {
    const record = { name, isAdmin, key };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record)); } catch { /* noop */ }
    setUser(record);
  };

  const signOut = () => {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* noop */ }
    setUser(null);
  };

  if (!user) return <Landing onSelect={signIn} />;
  return <Dashboard currentUser={user.name} isAdmin={user.isAdmin} adminKey={user.key} onSwitch={signOut} />;
}
